import { Button, Modal } from 'antd'
import React from 'react'

import { responsiveModalWidth } from '../../../util/guideline'
import { RfqQuotes } from './RfqQuotes'

export const RfqQuotesDrawer = ({ rfqQuotes, isVisible, onCancel, onClose }) => (
  <Modal
    title="Quotes"
    open={isVisible}
    onCancel={onCancel}
    width={responsiveModalWidth}
    footer={[
      <Button key="close" type="primary" onClick={onClose}>
        Close
      </Button>,
    ]}
  >
    <RfqQuotes rfqQuotes={rfqQuotes} />
  </Modal>
)
